<template>
  <div class="vendor-table">
    <form class="vendor-table__head">
      <div class="vendor-table__cell">№</div>
      <input-sort
        v-model="sortByName"
        v-on:input="sortVendorListByName"
        name="name"
      >
        <div
          class="vendor-table__cell sort"
          v-bind:class="{ selected: sortByName ? 'selected' : '' }">
          Наименование</div>
      </input-sort>
      <div class="vendor-table__cell">Контактное лицо</div>
      <div class="vendor-table__cell">Телефон</div>
      <div class="vendor-table__cell">Почта</div>
      <div class="vendor-table__cell">Адрес</div>
    </form>
    <div class="vendor-table__body-mobile">
      <button
        class="vendor-table__body-mobile__button-row"
        type="button"
        v-for="({
          id, name, contact, phone, email, address,
        }, index) in vendorList"
        v-bind:key="id"
        v-on:click="onEditVendor(id)">
        <dl class="vendor-table__body-mobile__row">
          <dt>№</dt>
          <dd>{{ index + 1 }}</dd>
          <dt>Наименование</dt>
          <dd>{{ name }}</dd>
          <dt>Контактное лицо</dt>
          <dd>{{ contact }}</dd>
          <dt>Телефон</dt>
          <dd>{{ phone }}</dd>
          <dt>Почта</dt>
          <dd>{{ email }}</dd>
          <dt>Адрес</dt>
          <dd>{{ address }}</dd>
        </dl>
      </button>
    </div>
    <div
      v-if="!this.isVendorListEmpty && !this.isAwaitRequest"
      class="vendor-table__body"
    >
      <div
        class="vendor-table__row"
        v-for="({
          id,
          name,
          contact,
          phone,
          email,
          address,
        }, index) in vendorList"
        v-bind:key="id">
        <div
          data-label="№"
          class="vendor-table__cell number">
          {{ index + 1 }}
        </div>
        <button
          class="vendor-table__cell fio"
          data-label="Наименование"
          title="Открыть"
          type="button"
          v-on:click="onEditVendor(id)"
        >
          {{ name }}
        </button>
        <div
          data-label="Контактное лицо"
          class="vendor-table__cell">{{ contact }}</div>
        <div
          data-label="Телефон"
          class="vendor-table__cell">{{ phone }}</div>
        <div
          data-label="Почта"
          class="vendor-table__cell">{{ email }}</div>
        <div
          data-label="Адрес"
          class="vendor-table__cell">{{ address }}</div>
        <div
          data-label="Редактировать"
          class="vendor-table__cell"
        >
          <button
            class="vendor-table__icon-edit"
            type="button"
            v-on:click="onEditVendor(id)" />
        </div>
        <div
          data-label="Удалить"
          class="vendor-table__cell">
          <button
            class="vendor-table__icon-delete"
            type="button"
            v-on:click="onDeleteVendor(id)" />
        </div>
      </div>
    </div>
    <div
      v-else-if="!isAwaitRequest"
      class="vendor-table__message"
    >
      Ничего не найдено
    </div>
  </div>
</template>
<script>
import InputSort from '@/components/InputSort.vue';

/**
 * @description Таблица поставщиков.
 * @type {any}
 */
export default {
  components: {
    InputSort,
  },
  computed: {
    /**
     * @description Является ли список поставщиков пустым.
     * @returns {boolean}
     */
    isVendorListEmpty() {
      return !Object.keys(this.vendorList).length;
    },
  },
  created() {
    this.sortByName = this.sort.type === 'name' ? this.sort.order : '';
  },
  data() {
    return {
      sortByName: '',
    };
  },
  methods: {
    /**
     * Сортировать список поставщиков по полному имени
     */
    sortVendorListByName() {
      this.$emit('sort-vendor-list', {
        type: 'name',
        order: this.sortByName,
      });
    },
    /**
     * @description Обработать удаление поставщика.
     * @param {number} id Идентификатор поставщика.
     * @returns {void}
     */
    onDeleteVendor(id) {
      this.$emit('delete-vendor', id);
    },
    /**
     * @description Обработать редактирование поставщика.
     * @param {number} id Идентификатор поставщика.
     * @returns {void}
     */
    onEditVendor(id) {
      this.$emit('edit-vendor', id);
    },
  },
  props: {
    /**
     * @description Список поставщиков.
     * @type {any[]}
     */
    vendorList: { type: Array, required: true },
    /**
     * @description Ожидание завершения запроса.
     * @type {boolean}
     */
    isAwaitRequest: { type: Boolean, required: true },
    /**
     * @description Тип сортировки
     * @type {Object}
     */
    sort: { type: Object, default: () => ({ type: '', order: '' }) },
  },
};
</script>
<style lang="scss">

.vendor-table {
  margin: 25px 0 0 0;
  font-size: 0.875rem;
  line-height: 1rem;
  &__body-mobile {
    display: none;
    flex-direction: column;
    gap: 10px;
    &__button-row {
      &:nth-child(odd) {
        background-color: var(--fill-color);
      }
    }
    &__row {
      display: grid;
      font-size: 12px;
      grid-template-columns: auto 1fr;
      justify-items: flex-end;
      align-items: center;
      row-gap: 5px;
      padding: 5px;
      & > dt {
        justify-self: flex-start;
      }
      & > dd {
        text-align: right;
      }
    }
  }
  &__head,
  &__row {
    display: grid;
    grid-template-columns:
      60px
      minmax(200px, 1fr)
      minmax(130px, 300px)
      repeat(2, 200px)
      minmax(200px, 400px)
      repeat(2, 43px);
    align-items: center;
    font-size: 14px;
    line-height: 17px;
  }
  &__head {
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
  }
  &__row {
    border-bottom: 1px solid #eaeff3;
    padding: 0;
    &:hover {
      background: #eaeff3;
    }
  }
  &__cell {
    padding: 12px 8px;
    transition: color var(--animate-duration);
    &.sort {
      text-align: left;
      cursor: pointer;
      display: flex;
      align-items: center;
      &:after {
        content: '';
        background-image: url("@/assets/img/checked/checked-grey.svg");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        width: 10px;
        height: 10px;
        margin: 0 0 0 5px;
      }
      &:hover {
        text-decoration: none;
      }
      &.selected {
        color: var(--action-color);
      }
    }
    .theme--light.v-icon:focus:after {
      opacity: 0;
    }
    &.fio {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      text-align: left;
      padding: 0;
      button:first-child {
        text-align: left;
      }
      &:hover {
        cursor: pointer;
        color: var(--action-color);
      }
    }
    &.success,
    &.fail,
    &.none {
      display: flex;
      align-items: center;
    }
    &.success:before,
    &.fail:before,
    &.none:before {
      content: '';
      height: 20px;
      margin-right: 10px;
      width: 20px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
    &.success {
      background: #E4FFEC !important;
      &:before {
        background-image: url("@/assets/img/checked/all-checked-green.svg");
      }
    }
    &.fail {
      background: #FFECEC;
      &:before {
        background-image: url("@/assets/img/exit-red.svg");
      }
    }
    &.none:before {
      height: 6px;
      width: 6px;
      background: #ABB1A3;
      border-radius: 50%;
      margin: 0 10px 0 6px;
    }
  }
  &__cell.cda-completeness {
    font-size: 0px;
    &::after {
      font-size: 1rem;
    }
    &.empty::after {
      content: '-';
    }
    &.full::after {
      content: '+';
    }
    &.unknown::after {
      content: '?';
    }
  }
  &__message {
    text-align: center;
    padding-top: 40px;
    font-size: 24px;
  }
  &__icon {
    &-edit {
      display: block;
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &-delete {
      display: block;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 12px;
      height: 12px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
    &-download {
      display: block;
      background-image: url("@/assets/img/download-file.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 20px;
      height: 20px;
      padding: 0;
      margin: 0;
      cursor: pointer;
    }
    &-copy {
      display: block;
      background-image: url("@/assets/img/copy-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      min-width: 14px;
      height: 14px;
      min-height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/copy-blue.svg");
      }
    }
  }
}
@media screen and (max-width: 1400px) {
  .vendor-table {
    &__head,
    &__row {
      grid-template-columns: 60px repeat(5, 1fr) repeat(2, 43px);
      font-size: 12px;
      line-height: 17px;
    }
  }
}
@media screen and (max-width: 1100px) {
  .vendor-table {
    &__head {
      display: none;
    }
    &__row {
      grid-template-columns: 1fr;
      grid-gap: 10px;
      margin: 0 0 20px 0;
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      text-align: right;
      padding: 0;
      &.fio {
        text-align: right;
      }
    }
    &__cell::before {
      content: attr(data-label);
      font-weight: 700;
      margin-right: 20px;
      font-size: 12px;
    }
  }
}
@media screen and (max-width: 480px) {
  .vendor-table__body {
    display: none;
    &-mobile {
      display: flex;
    }
  }
}
</style>
